<template>
  <div id="news_href" class="md:flex max-w-7xl mx-auto sm:px-10 my-12">
    <div class="board board-small flex-shrink-0 flex-grow-0 mx-auto">
      <img src="@/assets/count.png" alt="數量統計" class="pt-12 lg:pt-16 mx-auto" />
      <div class="grid grid-cols-1 divide-y leading-9 lg:leading-10 text-lg text-left mx-5 lg:mx-10 mt-2">
        <p class="statistics-item">
          <span>典藏標本數量</span>
          <span>{{ statistics.num_of_specimens }}</span>
        </p>
        <p class="statistics-item">
          <span>標本影像數量</span>
          <span>{{ statistics.checked_specimen_images }}</span>
        </p>
        <p class="statistics-item">
          <span>影像下載次數</span>
          <span>{{ statistics.image_download_times }}</span>
        </p>
        <p class="statistics-item">
          <span>資料下載次數</span>
          <span>{{ statistics.excel_request_count }}</span>
        </p>
        <p class="statistics-item">
          <span>瀏覽量</span>
          <span>{{ statistics.total_visits }}</span>
        </p>
      </div>
    </div>
    <div
      class=" mt-10 md:mt-0 md:ml-10 px-10 sm:px-0 xl:ml-20 flex-shrink-1 flex-grow-1 overflow-hidden w-full"
      v-if="loadingData"
    >
      <div class="flex justify-center sm:justify-between">
        <img src="@/assets/title-news.svg" alt="最新消息"/>
        <div class="hidden sm:block">
          <router-link to="/news">
            <div class="more-news text-white flex items-center justify-center">
              更多消息&ensp;>
            </div>
          </router-link>
        </div>
      </div>
      <div
        v-for="aNews in news"
        :key="aNews.id"
        class="bg-gray-200 rounded-full h-16 mt-4 lg:mt-6 py-2 px-8 flex items-center justify-center sm:justify-start text-lg"
      >
        <p class="truncate">
          <span class="date flex-none"> {{ aNews.date }}&emsp; </span>
          <br class="sm:hidden" />
          <router-link :to="`/news/${aNews.id}`" >
            {{ aNews.title }}
          </router-link>
        </p>
      </div>
    </div>
    <router-link to="/news">
      <div
        class="mt-5 mx-auto more-news text-white flex items-center justify-center sm:hidden"
      >
        更多消息&emsp;>
      </div>
    </router-link>
  </div>
</template>

<script>
import { getNews } from '@/api/news'
import { getStatistics } from '@/api/counter'

export default {
  name: "News",
  data() {
    return {
      content: "",
      news: [],
      loadingData: false,
      statistics: {}
    };
  },
  mounted() {
    getNews(1).then(
      response => {
        this.news = response.data.slice(0, 3);
        this.loadingData = true;
      },
      error => {
        this.content = this.errorMessage(error);
      }
    );

    getStatistics().then(
      response => {
        this.statistics = response.data;
      },
      error => {
        this.errorMsg = this.errorMessage(error);
      }
    );
  },
  methods: {
    errorMessage: function(error) {
      return (
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        (Array.isArray(error) ? error.toString() : '')
      );
    }
  }
}
</script>

<style scoped>
@media (min-width: 1024px) {
  .board {
    width: 320px;
    height: 343px;
    background-image: url("../../assets/board.png");
  }
}

@media (max-width: 1023.98px) {
  .board-small {
    width: 280px;
    height: 300px;
    background-image: url("../../assets/board.png");
    background-size: cover;
  }
}

.more-news {
  width: 125px;
  height: 50px;
  background-color: #64859d;
  mask-image: url(../../assets/btn-bg.svg);
}

.more-news:hover {
  background-color: #405d73;
}

.date {
  color: #405d73;
}

.statistics-item {
  @apply flex flex-row gap-5 items-center justify-between px-5;
}
</style>
